module.exports = __webpack_public_path__ + "static/media/10.097b7a85.jpg";